export class VisitorInfo {
  VISID: string;
  PASSPORTNO: string;
  NAME: string;
  EMAIL: string;
  PHONEPRIVATE: string;
  PHONEMOBILE: string;
  COMPANYID: string;
  COMPANYNO: string;
  CMPCOANDAR: string;
  CMPDCANDAR: string;
  REASON: string;
  QRCODE: string;
  CARDNO: string;
  SITECODE: string;
  ARRIVALEXPECTED: string | any;
  DEPARTEXPECTED: string | any;
  AUTHFROM: string;
  AUTHUNTIL: string | any;
  AUTHID: string | any;
  REMARKS: string;
  PHOTOIMAGE: string;
  ATTENDANTID: string;
  ATTENDANTNAME: string;

  constructor() {
    this.VISID = "";
    this.PASSPORTNO = "";
    this.NAME = "";
    this.EMAIL = "";
    this.PHONEMOBILE = "";
    this.PHONEPRIVATE = "";
    this.COMPANYID = "";
    this.COMPANYNO = "";
    this.CMPCOANDAR = "";
    this.CMPDCANDAR = "";
    this.REASON = "";
    this.QRCODE = "";
    this.CARDNO = "";
    this.SITECODE = "";
    this.ARRIVALEXPECTED = "";
    this.DEPARTEXPECTED = "";
    this.AUTHID = "";
    this.AUTHFROM = "";
    this.AUTHUNTIL = "";
    this.REMARKS = "";
    this.PHOTOIMAGE = "";
    this.ATTENDANTID = "";
    this.ATTENDANTNAME = "";
  }
}
